import React from 'react'
import { JsonLd } from 'react-schemaorg'
import { WebPage } from 'schema-dts'
import { usePageContext } from 'src/contexts/page.context'
import { useSecurityContext } from 'src/contexts/security.context'
import {
  makeGoogleTicker,
  makeSecurityDescription,
  makeSecurityLink,
} from 'src/shared/utils'

export const WebsiteSchema: React.FC = () => {
  const { siteUrl } = usePageContext()
  const { security } = useSecurityContext()

  return (
    <JsonLd<WebPage>
      item={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        url: `${siteUrl}${makeSecurityLink(security)}`,
        name: `📈 ${security.name} Share Price - ${makeGoogleTicker(
          security,
        )} Share Price`,
        description: makeSecurityDescription(security),
        publisher: 'Stockopedia',
        mentions: [
          {
            '@type': 'Corporation',
            name: security.name,
            tickerSymbol: makeGoogleTicker(security),
          },
        ],
      }}
    />
  )
}
